module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox, $) {
	'use strict';
	require('widget/autocomplete2')(fox);
	
	fox.registerWidget('Autocomplete2_MultipleSelect', {

		configure: function () {
			this.filteredData = [];
			this.selectedData = [];

			this.registerOptions('', {
				
				loadAll: true,
				staticFilter: true,
				returnParam: 'id',
				widgets: {
					input: {
						'embed.container': '.niches-wrapper',
						template: 'autocomplete2_multipleSelect',
						templateOptions: {
							placeholder: '',
						}
					},
					'list.tpl.row': 'autocomplete2_multipleSelect_list_item',
					selectedList: {
						widget: 'List',
						embed: {
							widget: '@parent #input',
							container: '[fox-autocomplete-selected-list]'
						},
						'tpl.row': 'autocomplete2_multipleSelect_selected_list_item'
					}
				},

				handleDom: {
					removeSelected: {
						targetWidget: '#selectedList',
						target: '.delete',
						event: 'click',
						callback: '_removeFromSelectedList'
					},
					focusOnClick: {
						targetWidget: '#input',
						target: '.mc-form-field',
						event: 'click',
						callback: '_focus'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		running: function () {
			this.callParent('running', arguments);

			this.selectedList = this.wom1('#selectedList');
		},

		reset: function () {
			this.selectedData = [];
			this.renderSelectedList();

			//this.resultList.setCollection([]);
			//this.filteredData = fox.clone(this.responseData);
			this.renderResultList(this.responseData);
			this.searchStr = '';
			this.fillInput('');
		},

		deactivate: function () {
			this.callParent('deactivate', arguments);
		},

		_bindKeyboardEvents: function () {
			$(window).on('keyup', {widget: this}, this._onKeydown);

			this.callParent('_bindKeyboardEvents', arguments);
		},

		_onKeydown: function (e) {
			var code = e.keyCode;

			if (fox.inArray([13, 8], code)) {
				e.preventDefault();
			}
		},

		select: function (node) {
			node = fox.dom.wrap(node);
			this.dispatchEvent('search_form_submit');

			this.moveToSelectedList(node.attr('fox-autocomplete-search-result'));
			this.renderSelectedList();
		},

		renderResultList: function (data) {
			this.prepareResultList(data);
			this.resultList.setCollection(this.filteredData, true);
		},

		prepareResultList: function (data) {
			this.filteredData = data.filter(function (item) {
				var result = true;

				fox.each(this.selectedData, function (selectedItem) {
					if (selectedItem.id === item.id) {
						result = false;
					}
				}, this);

				return result;
			}.bind(this));
		},

		moveToSelectedList: function (item) {
			var i;

			item = fox.isString(item) && fox.isNumeric(item) ? window.parseInt(item) : item;

			fox.each(this.filteredData, function (data, n) {

				if (data.id === item) {
					this.selectedData.push(data);
					i = n;
				}
			}, this);

			if (!fox.isEmpty(i)) {
				this.filteredData.splice(i, 1);
			}
			
			this.renderResultList(this.filteredData);
		},

		renderSelectedList: function () {
			this.selectedList.setCollection(this.selectedData, true);
		},

		_removeFromSelectedList: function (node) {
			node = fox.dom.wrap(node);//
			var attr = node.attr('fox-autocomplete-filter-result');

			attr = fox.isString(attr) && fox.isNumeric(attr) ? window.parseInt(attr) : attr;

			this.selectedData = this.selectedData.filter(function (data) {
				if (data.id === attr) {
					return false;
				}
				return true;
			}.bind(this));

			this.renderSelectedList();
			this.filterData();
		},

		hideList: function () {
			fox.dom.removeClass('opened', this.input.dom1('.dropdown'));
		},

		showList: function () {
			fox.dom.addClass('opened', this.input.dom1('.dropdown'));
		},

		_focus: function (el, alias, w, e) {
			fox.dom.event.stop(e);

			if (typeof e.stopPropagation !== "undefined") {
				e.stopPropagation();
			} else if (typeof e.cancelBubble !== "undefined") {
				e.cancelBubble = true;
			}

			w.dom1('[fox-autocomplete-input]').focus();
		},

		getValue: function () {
			var param = this.getOption('returnParam');

			if (!param) {
				return this.selectedData;
			}
			
			return this.selectedData.map(function (item){
				return item[param];
			});
		},

		setValue: function (values, returnParam) {
			fox.each(values, function (val) {
				this.moveToSelectedList(val);
			}, this);

			this.renderSelectedList();
		}

	}, 'Autocomplete2');
})(fox, fox.jQuery);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ./widget/multipleAutocompleteSelect.js
// module id = 199
// module chunks = 5